(function () {
  'use strict';

  let clampId = 0;

  function getClampTarget(setElement) {
    return (
      setElement.querySelector('.swatch-master-frame') ||
      setElement.querySelector('.swatch-row') ||
      setElement.querySelector('.sub-swatch-row')
    );
  }

  function wireShowHide(setElement) {
    if (!setElement || setElement.dataset.showMoreBound === '1') return;

    const target = getClampTarget(setElement);
    if (!target) return;

    const strings = window.customizerStrings || {};
    const showText = strings.show_colours || 'Show colours ▾';
    const hideText = strings.hide_colours || 'Hide colours ▴';

    const wrap = document.createElement('div');
    wrap.className = 'clamp-wrap';
    target.parentNode.insertBefore(wrap, target);
    wrap.appendChild(target);

    if (!wrap.id) {
      clampId += 1;
      wrap.id = `ls-swatch-clamp-${clampId}`;
    }

    const showButton = document.createElement('button');
    showButton.type = 'button';
    showButton.className = 'show-more-swatches';
    showButton.setAttribute('aria-expanded', 'false');
    showButton.setAttribute('aria-controls', wrap.id);
    showButton.textContent = showText;

    const hideTopButton = document.createElement('button');
    hideTopButton.type = 'button';
    hideTopButton.className = 'show-more-swatches';
    hideTopButton.setAttribute('aria-controls', wrap.id);
    hideTopButton.textContent = hideText;

    const hideBottomButton = hideTopButton.cloneNode(true);

    wrap.before(showButton);
    wrap.before(hideTopButton);

    function setExpanded(expanded) {
      wrap.classList.toggle('expanded', expanded);
      showButton.style.display = expanded ? 'none' : 'block';
      hideTopButton.style.display = expanded ? 'block' : 'none';
      hideBottomButton.style.display = expanded ? 'block' : 'none';
      showButton.setAttribute('aria-expanded', String(expanded));
      hideTopButton.setAttribute('aria-expanded', String(expanded));
      hideBottomButton.setAttribute('aria-expanded', String(expanded));
    }

    setExpanded(false);

    showButton.addEventListener('click', () => setExpanded(true));
    hideTopButton.addEventListener('click', () => {
      setExpanded(false);
      showButton.focus();
    });
    hideBottomButton.addEventListener('click', () => {
      setExpanded(false);
      showButton.focus();
    });

    setElement._lsClamp = {
      setExpanded,
      wrap,
      showButton,
      hideTopButton,
      hideBottomButton,
    };

    setElement.dataset.showMoreBound = '1';
  }

  window.collapseSwatchSet = function collapseSwatchSet(setElement) {
    if (setElement && setElement._lsClamp) {
      setElement._lsClamp.setExpanded(false);
    }
  };

  window.expandSwatchSet = function expandSwatchSet(setElement) {
    if (setElement && setElement._lsClamp) {
      setElement._lsClamp.setExpanded(true);
    }
  };

  function initialiseSwatches() {
    document.querySelectorAll('#swatch-sets .swatch-set').forEach(wireShowHide);

    const drip = document.getElementById('drip-swatch-sets');
    if (drip) wireShowHide(drip);
  }

  function initialiseCustomisationObserver() {
    const panel = document.getElementById('customisation-panel');
    if (!panel || panel.dataset.lsSwatchObserverBound === '1') return;

    const observer = new MutationObserver(initialiseSwatches);
    observer.observe(panel, { childList: true, subtree: true });
    panel.dataset.lsSwatchObserverBound = '1';
  }

  function handleShippingToggle(event) {
    const toggle = event.target.closest('.shipping-toggle');
    if (!toggle) return;

    const controlsId = toggle.getAttribute('aria-controls') || 'shipping-content';
    const content = document.getElementById(controlsId);
    if (!content) return;

    const isOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!isOpen));
    content.classList.toggle('open', !isOpen);
    content.setAttribute('aria-hidden', String(isOpen));
  }

  function initialiseShippingAccessibility() {
    document.querySelectorAll('.shipping-toggle[aria-controls]').forEach((toggle) => {
      const content = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!content) return;

      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      content.setAttribute('aria-hidden', String(!expanded));
    });
  }

  function boot() {
    initialiseSwatches();
    initialiseCustomisationObserver();
    initialiseShippingAccessibility();
    document.addEventListener('click', handleShippingToggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
